import React from 'react';
import { Container, Row, Col } from 'reactstrap';
import { SEO } from 'components/SEO';

export const PrivacyPolicy: React.FC = () => {
  return (
    <Container className="py-5">
      <SEO 
        title="Privacy Policy - Speak on Steem" 
        description="Privacy policy for the Speak on Steem platform."
      />
      <Row className="justify-content-center">
        <Col md={10} lg={8}>
          <div className="legal-content card item-speem p-4">
            <h1 className="mb-4">Privacy Policy</h1>
            <p className="text-muted">Last Updated: April 19, 2026</p>

            <section className="mb-4">
              <h2>1. Introduction</h2>
              <p>
                Welcome to Speak on Steem ("we," "our," or "us"). We are committed to protecting your personal information and your right to privacy. 
                This Privacy Policy explains how we collect, use, and disclose information when you use our platform, which operates on the Steem Blockchain.
              </p>
            </section>

            <section className="mb-4">
              <h2>2. Information We Collect</h2>
              <p>
                <strong>Blockchain Data:</strong> Since Speak on Steem is a decentralized application, most of your interactions (posts, comments, votes, transfers) 
                are stored publicly on the Steem Blockchain. We do not control this information.
              </p>
              <p>
                <strong>Off-Chain Data:</strong> We may collect minimal off-chain information such as your IP address, browser type, and usage patterns 
                through analytics tools to improve our service and provide security.
              </p>
            </section>

            <section className="mb-4">
              <h2>3. How We Use Your Information</h2>
              <p>
                We use the information we collect to:
              </p>
              <ul>
                <li>Provide, operate, and maintain our platform.</li>
                <li>Improve and personalize your experience.</li>
                <li>Analyze how you use our platform.</li>
                <li>Prevent fraudulent transactions and protect against platform abuse.</li>
              </ul>
            </section>

            <section className="mb-4">
              <h2>4. Third-Party Services</h2>
              <p>
                We use third-party services like Google AdSense to serve advertisements. These services may use cookies and web beacons 
                to collect information as a result of ad serving on our platform. Google’s use of advertising cookies enables it and its 
                partners to serve ads to users based on their visit to our site and/or other sites on the Internet.
              </p>
            </section>

            <section className="mb-4">
              <h2>5. Your Rights</h2>
              <p>
                Depending on your location, you may have rights regarding your personal data, including the right to access, correct, 
                or delete the information we hold about you off-chain. Please note that data written to the Steem Blockchain is immutable 
                and cannot be deleted.
              </p>
            </section>

            <section className="mb-4">
              <h2>6. Contact Us</h2>
              <p>
                If you have questions or comments about this policy, you may contact us at: <strong>speakonsteem@gmail.com</strong>
              </p>
            </section>
          </div>
        </Col>
      </Row>
    </Container>
  );
};
